
// import React from "react";
// import SecondNav from "../Navbar/SecondNav";
// import TopNavbar from "../Navbar/TopNavbar";
// import Section2 from "./Section2";
// import Section1 from "./Section1";
// import Section3 from "./Section3";
// import Footer from "./Footer";
// import "./HomePage.css"; // Import the CSS file for scrollbar styling
// import Section4 from "./Section4";

// function HomePage() {
//   return (
//     <div
//       className="home-page"
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         backgroundColor: "#f5f5f5",
//       }}
//     >
//       <TopNavbar />
//       <SecondNav />
      
//       <div style={{ marginTop: "20px" }}>
//         {/* Wrapper for Section1 */}
//         <div style={{ marginBottom: "40px", backgroundColor: "#e0f7fa", padding: "20px" }}>
//           <Section1 />
//         </div>

//         {/* Wrapper for Section2 */}
//         <div style={{ backgroundColor: "#fff3e0", padding: "20px" }}>
//           <Section2 />
//         </div>
//         {/* Wrapper for Section3 */}
//         <div style={{ backgroundColor: "#fff3e0", padding: "20px" }}>
//           <Section3 />
//         </div>
//         {/* Wrapper for Section4 */}
//         <div style={{ backgroundColor: "#fff3e0", padding: "20px" }}>
//           <Section4/>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// }

// export default HomePage;

// import React from "react";
// import SecondNav from "../Navbar/SecondNav";
// import TopNavbar from "../Navbar/TopNavbar";
// import Section2 from "./Section2";
// import Section1 from "./Section1";
// import Section3 from "./Section3";
// import Footer from "./Footer";
// import "./HomePage.css"; // Import the CSS file for scrollbar styling
// import Section4 from "./Section4";
// import ChatPopup from "./ChatPopup"; // Import the ChatPopup component

// function HomePage() {
//   return (
//     <div
//       className="home-page"
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         backgroundColor: "#f5f5f5",
//         position: "relative", // Ensure the parent has a position context for the fixed ChatPopup
//       }}
//     >
//       <TopNavbar />
//       <SecondNav />
      
//        <div style={{ marginTop: "20px" }}>
     
//        <Section1 />
        
          
//            {/* Wrapper for Section3 */}
//         <div style={{ backgroundColor: "#fff3e0", padding: "20px" }}>
//          <Section2 />
//         </div>
       
//         {/* Wrapper for Section3 */}
//         <div style={{ backgroundColor: "#fff3e0", padding: "20px" }}>
//           <Section3 />
//         </div>
//         {/* Wrapper for Section4 */}
//         <div style={{ backgroundColor: "#fff3e0", padding: "20px" }}>
//           <Section4 />
//         </div>
//       </div> 
//       <Footer />

//       {/* Add the ChatPopup component */}
//       <ChatPopup />
//     </div>
//   );
// }

// export default HomePage;










import React from "react";
import SecondNav from "../Navbar/SecondNav";
import TopNavbar from "../Navbar/TopNavbar";
import Section2 from "./Section2";
import Section1 from "./Section1";
import Section3 from "./Section3";
import Footer from "./Footer";
import "./HomePage.css"; // Import the CSS file for scrollbar styling
import Section4 from "./Section4";
import ChatPopup from "./ChatPopup"; // Import the ChatPopup component
import { useMediaQuery } from "@mui/material";

function HomePage() {
  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <div
      className="home-page"
      style={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
       
        overflowX: "hidden",
      }}
    >
      {/* Navbar section */}
      <div style={{ position: "sticky", top: 0, zIndex: 1000 }}>
        <TopNavbar />
        <SecondNav />
      </div>

      {/* Main content */}
    
        {/* Section 1 */}
        
          <Section1 />
       

        {/* Section 2 */}
      
          {/* <Section2 /> */}
        <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "40px",
        padding: "40px 20px",
        backgroundColor: "#090000ff",
        maxWidth: "1400px",
        margin: "auto",
        marginTop: "-30px",
        flexWrap: "wrap",
        textAlign: "left",
      }}
    >
      <style>
        {`
          @media (max-width: 768px) {
            .single-section {
              flex-direction: column !important;
              text-align: center !important;
              gap: 20px !important;
              padding: 30px 15px !important;
            }
          }
        `}
      </style>

      <img
        src="https://images.pexels.com/photos/170811/pexels-photo-170811.jpeg"
        alt="Feature"
        style={{
          width: "100%",
          maxWidth: "450px",
          borderRadius: "10px",
          objectFit: "cover",
        }}
      />
      <div>
        <h2 style={{ fontSize: "2rem", marginBottom: "15px", color: "#fff" }}>
          Our Amazing Feature
        </h2>
        <p style={{ fontSize: "1.1rem", lineHeight: "1.6", color: "#fff" }}>
          Experience the best-in-class performance and smooth user experience
          with our latest solution. It adapts beautifully to all screen sizes
          and ensures seamless functionality across devices.
        </p>
      </div>
    </div>

        {/* Section 3 */}
        {/* <div
          style={{
            backgroundColor: "#fff3e0",
            padding: isMobile ? "10px" : "20px",
          }}
        >
          <Section3 />
        </div> */}

        {/* Section 4 */}
        <div
          style={{
            backgroundColor: "#fff3e0",
            padding: isMobile ? "10px" : "20px",
          }}
        >
          <Section4 />
        </div>
     

      {/* Footer */}
      <Footer />

      {/* Floating Chat Popup */}
      <ChatPopup />
    </div>
  );
}

export default HomePage;
